import { useLocaleStore } from "@dealer-center/core-locale";
import { useGetAccount } from "@dealer-center/ddc-api-account-fetch";
import { useQuery } from "@tanstack/react-query";
import ky from "ky";
import type { navbarInterface } from "@dealer-center/ddc-api-commoncontainer-interface";

const queryKeyBase = "ddc-api-commoncontainer";

const staleTime = 600000; // 10 mins
export function useNavbarItems() {
  const locale = useLocaleStore(state => state.locale);
  const { data: accountEntity, isLoading } = useGetAccount();

  return useQuery({
    queryKey: [queryKeyBase, accountEntity?.id],
    queryFn: () => fetchNavbarItems(accountEntity?.id, locale),
    staleTime,
    enabled: !isLoading,
    retry: false,
    select: data => {
      return data;
    }
  });
}

const fetchNavbarItems = (account?: string, locale?: string) => {
  const url = getApiUrl(locale || "en-US", account);
  try {
    return ky.get(url).json<navbarInterface>();
  } catch (error) {
    return Promise.reject(error);
  }
};

function getApiUrl(locale: string, selectedDealer?: string) {
  const langUrlPart = `?locale=${locale}`.replace("_", "-");
  if (!selectedDealer) {
    return "/landing/nxlambda/commoncontainer/" + langUrlPart;
  }

  return "/landing/nxlambda/commoncontainer/" + selectedDealer + langUrlPart;
}
